/*
 *
 * CheckRefundableTransactionModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 02-Jul-2025
*/

import CheckRefundableTransactionModal from './CheckRefundableTransactionModalContainer'

export default CheckRefundableTransactionModal
